import { render, staticRenderFns } from "./beneficiary-home-phone.vue?vue&type=template&id=5a328cdc&"
import script from "./beneficiary-home-phone.vue?vue&type=script&lang=js&"
export * from "./beneficiary-home-phone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports